var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect6, _rect7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect8, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 386,
    viewBox: "0 0 487 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 62.3921,
    width: 440,
    height: 261,
    fill: "white",
    stroke: "#1A1B22"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 62.8921,
    width: 439,
    height: 20,
    fill: "#5A9BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 112.392,
    width: 109,
    height: 60,
    stroke: "#1A1B22",
    strokeLinejoin: "round",
    strokeDasharray: "9 9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 112.392,
    width: 109,
    height: 60,
    stroke: "#1A1B22",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 283.5,
    y: 112.392,
    width: 109,
    height: 60,
    stroke: "#1A1B22",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.488 115.171L275.655 132.106L299.82 121.636L282.885 141.804L293.355 165.969L273.187 149.034L249.022 159.503L265.957 139.335L255.488 115.171Z",
    fill: "#1A1B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420 67.8921L430 77.8921M430 67.8921L420 77.8921",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.721,
    cy: 138.917,
    r: 3.721,
    fill: "#1A1B22"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.963,
    cy: 160.623,
    r: 1.8605,
    fill: "#1A1B22"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.857,
    cy: 45.8922,
    r: 1.24033,
    fill: "#1A1B22"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 381.276,
    cy: 81.8619,
    r: 1.24033,
    fill: "#1A1B22"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.518,
    cy: 141.398,
    r: 1.24033,
    fill: "#1A1B22"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.337,
    cy: 158.763,
    r: 1.24033,
    fill: "#1A1B22"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.6,
    cy: 213.338,
    r: 1.24033,
    fill: "#1A1B22"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.61,
    cy: 181.709,
    r: 1.8605,
    fill: "#1A1B22"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.09,
    cy: 217.679,
    r: 1.8605,
    fill: "#1A1B22"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.451,
    cy: 102.948,
    r: 3.721,
    fill: "#1A1B22"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.87,
    cy: 16.1243,
    r: 3.721,
    fill: "#1A1B22"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.561,
    cy: 254.268,
    r: 3.721,
    fill: "#1A1B22"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 325.462,
    y: 235.031,
    width: 14.884,
    height: 213.454,
    rx: 3,
    transform: "rotate(-45.0322 325.462 235.031)",
    fill: "#1A1B22"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 342.721,
    y: 251.584,
    width: 13.884,
    height: 7.61387,
    transform: "rotate(-45.0322 342.721 251.584)",
    fill: "white",
    stroke: "#1A1B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.176 221.604L300.25 235.886L314.847 238.626L300.565 242.701L297.824 257.297L293.75 243.015L279.153 240.275L293.435 236.201L296.176 221.604Z",
    fill: "#1A1B22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.635 93.8493L369.709 108.132L384.306 110.872L370.024 114.946L367.283 129.543L363.209 115.261L348.612 112.52L362.894 108.446L365.635 93.8493Z",
    fill: "#1A1B22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.347 22.4423L249.568 40.7503L267.831 45.1592L249.523 49.3801L245.115 67.6437L240.894 49.3357L222.63 44.9269L240.938 40.7059L245.347 22.4423Z",
    fill: "#1A1B22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.964 178.317L168.605 194.619L184.506 198.237L168.203 197.879L164.585 213.779L164.943 197.477L149.043 193.859L165.346 194.217L168.964 178.317Z",
    fill: "#1A1B22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.373 91.885L194.415 102.473L204.997 103.574L194.409 104.616L193.308 115.199L192.266 104.61L181.683 103.509L192.272 102.467L193.373 91.885Z",
    fill: "#1A1B22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.021 48.7865L135.742 58.7542L146.253 57.1063L136.285 60.8272L137.933 71.3383L134.212 61.3707L123.701 63.0186L133.669 59.2977L132.021 48.7865Z",
    fill: "#1A1B22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.078 0.0275458L282.963 9.01579L291.946 9.95042L282.957 10.835L282.023 19.8182L281.138 10.83L272.155 9.89533L281.143 9.01073L282.078 0.0275458Z",
    fill: "#1A1B22"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 186.392,
    width: 227,
    height: 124,
    stroke: "#1A1B22",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.936 224.058C148.309 224.016 150.583 222.921 152.094 221.092L152.48 221.411C153.254 220.474 153.84 219.356 154.158 218.096C154.378 217.225 154.715 216.459 155.139 215.795L154.718 215.526C155.73 213.943 157.22 212.883 158.873 212.346L159.027 212.821C160.622 212.304 162.378 212.304 163.973 212.821L164.127 212.346C165.78 212.883 167.27 213.943 168.282 215.526L167.861 215.795C168.285 216.459 168.622 217.225 168.842 218.096C169.16 219.356 169.746 220.474 170.52 221.411L170.906 221.092C172.417 222.921 174.691 224.016 177.064 224.058L177.055 224.558C178.27 224.579 179.51 224.34 180.693 223.803C181.511 223.432 182.32 223.218 183.103 223.136L183.051 222.639C184.92 222.442 186.678 222.947 188.129 223.904L187.853 224.322C189.252 225.245 190.347 226.619 190.936 228.188L191.404 228.012C192.015 229.639 192.116 231.465 191.509 233.244L191.035 233.082C190.781 233.828 190.392 234.569 189.848 235.283C189.062 236.318 188.553 237.473 188.303 238.663L188.793 238.765C188.305 241.087 188.867 243.548 190.313 245.429L189.917 245.734C190.658 246.697 191.618 247.517 192.776 248.108C193.575 248.516 194.247 249.015 194.8 249.576L195.156 249.225C196.475 250.564 197.177 252.253 197.332 253.984L196.834 254.029C196.984 255.698 196.593 257.411 195.734 258.85L196.163 259.106C195.272 260.598 193.907 261.815 192.138 262.45L191.969 261.979C191.227 262.245 190.406 262.403 189.508 262.423C188.209 262.453 186.988 262.776 185.903 263.322L186.127 263.769C184.008 264.835 182.434 266.809 181.866 269.112L181.381 268.993C181.09 270.173 181.047 271.434 181.307 272.708C181.486 273.587 181.515 274.424 181.421 275.206L181.917 275.266C181.693 277.131 180.81 278.733 179.553 279.934L179.208 279.572C177.996 280.73 176.413 281.493 174.753 281.718L174.82 282.214C173.098 282.447 171.295 282.139 169.696 281.151L169.959 280.726C169.289 280.312 168.653 279.768 168.077 279.079C167.243 278.082 166.23 277.328 165.126 276.82L164.917 277.274C162.762 276.283 160.238 276.283 158.083 277.274L157.874 276.82C156.77 277.328 155.757 278.082 154.923 279.079C154.347 279.768 153.711 280.312 153.041 280.726L153.304 281.151C151.705 282.139 149.902 282.447 148.18 282.214L148.247 281.718C146.587 281.493 145.004 280.73 143.792 279.572L143.447 279.934C142.19 278.733 141.307 277.131 141.083 275.266L141.579 275.206C141.485 274.424 141.514 273.587 141.693 272.708C141.953 271.434 141.91 270.172 141.619 268.993L141.134 269.112C140.566 266.809 138.992 264.835 136.873 263.769L137.097 263.322C136.012 262.776 134.791 262.453 133.492 262.423C132.594 262.403 131.773 262.245 131.031 261.979L130.862 262.45C129.093 261.815 127.728 260.598 126.837 259.106L127.266 258.85C126.407 257.411 126.016 255.698 126.166 254.029L125.668 253.984C125.823 252.253 126.525 250.564 127.844 249.225L128.2 249.576C128.753 249.015 129.425 248.516 130.224 248.108C131.382 247.517 132.342 246.697 133.083 245.734L132.687 245.429C134.133 243.548 134.695 241.087 134.207 238.765L134.697 238.663C134.447 237.473 133.938 236.318 133.151 235.283C132.608 234.569 132.219 233.828 131.965 233.082L131.491 233.244C130.884 231.465 130.985 229.639 131.596 228.012L132.064 228.188C132.653 226.619 133.748 225.245 135.147 224.322L134.871 223.904C136.322 222.947 138.08 222.442 139.949 222.639L139.897 223.136C140.68 223.218 141.489 223.432 142.307 223.803C143.49 224.34 144.73 224.579 145.945 224.558L145.936 224.058Z",
    stroke: "#1A1B22",
    strokeDasharray: "6 6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.20180063aef0651325dae97a8c14add9.svg";
export { ForwardRef as ReactComponent };